import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoadingLogo from './LoadingLogo';
import Seo from './Seo';

// Clean ProductListt component: defines fetchTestimonials and keeps handlers in-scope
const ProductListt = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchTestimonials() {
    try {
      const res = await axios.get('http://127.0.0.1:8000/api/acordio-getall/');
      setBlogPosts(res.data || []);
    } catch (err) {
      console.error('Error fetching testimonials:', err);
    } finally {
      setIsLoading(false);
    }
  }

  const handleChangePicture = (postId) => {
    const onFile = (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        const title = prompt('Enter the new title:');
        const description = prompt('Enter the new description:');
        if (!title || !description) return;
        try {
          const token = localStorage.getItem('token');
          await axios.put(`http://127.0.0.1:8000/api/acordio/${postId}/`, { image: base64, title, description }, { headers: { Authorization: `token ${token}` } });
          fetchTestimonials();
        } catch (err) {
          console.error(err);
        }
      };
      reader.readAsDataURL(file);
    };
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.addEventListener('change', onFile);
    input.click();
  };

  const handleAddImage = () => {
    const onFile = (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const title = prompt('Enter the title:');
      const description = prompt('Enter the description:');
      if (!title || !description) return;
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        const formData = new FormData();
        formData.append('image', base64);
        formData.append('title', title);
        formData.append('description', description);
        try {
          const token = localStorage.getItem('token');
          await axios.post('http://127.0.0.1:8000/api/acordio/create/', formData, { headers: { Authorization: `token ${token}`, 'Content-Type': 'multipart/form-data' } });
          fetchTestimonials();
        } catch (err) {
          console.error(err);
        }
      };
      reader.readAsDataURL(file);
    };
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.addEventListener('change', onFile);
    input.click();
  };

  const handleDelete = async (postId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`http://127.0.0.1:8000/api/acordio/${postId}/delete/`, { headers: { Authorization: `token ${token}` } });
      fetchTestimonials();
    } catch (err) {
      console.error(err);
    }
  };

  const products = [
    { id: 1, name: 'Product 1', description: 'Sample product description.' },
    { id: 2, name: 'Product 2', description: 'Sample product description.' },
    { id: 3, name: 'Product 3', description: 'Sample product description.' },
  ];

  const isLoggedIn = !!(localStorage.getItem('token') && localStorage.getItem('user'));

  const SupplierCard = ({ id, image, name, description }) => (
    <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg">
      <img className="w-full h-32 object-cover" src={image} alt={name} />
      <div className="p-2">
        <h3 className="text-lg font-medium mb-2">{name}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
      {isLoggedIn && (
        <div className="p-2 flex flex-row justify-end gap-2">
          <button className="text-white hover:bg-blue-800 mr-2 bg-blue-600 rounded-lg px-4 py-1" onClick={() => handleChangePicture(id)}>Edit</button>
          <button className="text-white hover:bg-red-800 mr-2 bg-red-600 rounded-lg px-4 py-1" onClick={() => handleDelete(id)}>Delete</button>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <Seo
        title="Product List | Synergy Industrial Automation Ethiopia"
        description="See our supplier cards and product list for industrial automation, PLC, and SCADA in Ethiopia."
        url="https://www.synergyindustri.com/productlist"
        image="https://www.synergyindustri.com/synergy-social.png"
        jsonLd={
          blogPosts && blogPosts.length
            ? {
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                itemListElement: blogPosts.slice(0, 50).map((p, i) => ({
                  '@type': 'ListItem',
                  position: i + 1,
                  name: p.title || p.name || `Item ${p.id}`,
                  url: `https://www.synergyindustri.com/productlist#${p.id}`
                }))
              }
            : undefined
        }
      />
      <div className="container mx-auto">
      <h1 className="text-xl font-bold my-4">Product List</h1>
      {isLoading ? (
        <LoadingLogo />
      ) : (
        <>
          {products.map((product) => (
            <div key={product.id} className="border rounded-lg p-2 mb-2 hover:bg-blue-400">
              <div className="flex items-center justify-between cursor-pointer" onClick={() => setActiveAccordion(product.id === activeAccordion ? null : product.id)}>
                <h3 className="text-sm font-semibold">{product.name}</h3>
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 transform ${activeAccordion === product.id ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              {activeAccordion === product.id && (<div className="mt-2"><p className="text-sm">{product.description}</p></div>)}
            </div>
          ))}

          <div className="border rounded-lg p-2 mt-4">
            <h2 className="text-xl font-bold mb-2">Our Brand and Insights</h2>
            <p className="text-sm">Short description about brand.</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-4">
            {blogPosts.map((post) => (
              <SupplierCard key={post.id} id={post.id} image={post.image} name={post.title} description={post.description} />
            ))}
          </div>

          {isLoggedIn && (
            <div className="flex justify-center items-center mt-4">
              <button className="text-white hover:bg-green-800 bg-green-600 rounded-lg px-4 py-2" onClick={handleAddImage}>Add Post</button>
            </div>
          )}
        </>
      )}
      </div>
    </div>
  );
};

export default ProductListt;

